import axios from "axios";

const USERS_SERVICE_BASE = `${process.env.REACT_APP_API_URL}/authservice/api/users`;

// Create an Axios instance
const apiClient = axios.create({
  baseURL: USERS_SERVICE_BASE,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const usersApi = {
  usersCount: async () => {
    try {
      const response = await apiClient.get("/count");
      return response.data;
    } catch (error) {
      console.error("Error fetching user count:", error);
      throw error;
    }
  },

  getAllUsers: () => apiClient.get("/allUsers"),

  updateUserRole: (userId, role, parentUserId) =>
    apiClient.put(`/updateUserRole/${userId}`, {
      role,
      parentUserId,
    }),

  getUsersList: (page, pageSize, sortedColumn, sortOrder, role) =>
    apiClient.get("/usersList", {
      params: {
        page,
        pageSize,
        sortedColumn,
        sortOrder,
        role,
      },
    }),

  getUsersListExceptMA: () => apiClient.get("/usersListExceptMA"),

  getCustomersListByReferralCode: (referralCode, page, pageSize) =>
    apiClient.get("/customers", {
      params: {
        referralCode,
        page,
        pageSize,
      },
    }),

  getReferredCutomers: (page, pageSize, sortedColumn, sortOrder, role) =>
    apiClient.get("/getReferredCutomers", {
      params: {
        page,
        pageSize,
        sortedColumn,
        sortOrder,
        role,
      },
    }),

  getNonReferredCutomers: (page, pageSize, sortedColumn, sortOrder, role) =>
    apiClient.get("/getNonReferredCutomers", {
      params: {
        page,
        pageSize,
        sortedColumn,
        sortOrder,
        role,
      },
    }),

  updateReferralCode: (userId, referralCode) =>
    apiClient.put(`/updateReferralCode/${userId}`, {
      referralCode,
    }),

    getCountOfCustomersByReferralCode: (referralCode) =>
    apiClient.get("/countCustomersByReferralCode", {
      params: {
        referralCode,
      },
    }),

  getUserDetails: (email) =>
    apiClient.get("/details", {
      params: { email },
    }),
};

export default usersApi;
